/* eslint-disable react/prop-types */

import { ModeAuthorizeEnum, PermissionMenuKey } from "../utils/constants";
import { useAuthorization } from "../hooks/useAuthorization";
import { Box, Typography } from "@mui/material";

function Authorize({ mode, children, permission, routerGroup }) {
  const useAuthorize = useAuthorization();
  const autoShow = [
    PermissionMenuKey.dashboard,
    PermissionMenuKey.home,
    PermissionMenuKey.gioiThieu,
    PermissionMenuKey.tinTuc,
    PermissionMenuKey.diaDiemDulich,
    PermissionMenuKey.banDoQuyHoach,
    PermissionMenuKey.capPhepXayDung,
    PermissionMenuKey.gopY,
    PermissionMenuKey.diadiem,
    PermissionMenuKey.chiTietDiaDiem,
    PermissionMenuKey.chiTietTinTuc,
    PermissionMenuKey.banDoSo,
    PermissionMenuKey.Place,
    PermissionMenuKey.Gallery,
    PermissionMenuKey.Relics,
    PermissionMenuKey.Discover,
    PermissionMenuKey.Company,
  ];

  let check = false;
  if (permission && useAuthorize.isPermission(permission)) {
    check = true;
  }
  if (permission && autoShow.includes(permission)) {
    check = true;
  }

  if (routerGroup?.length > 0 && useAuthorize.isPermissionGroup(routerGroup)) {
    check = true;
  }
  if (!check) {
    if (mode == ModeAuthorizeEnum.access && !useAuthorize?.isLogged) {
      location.href = `${window.location.origin}/sign-in`;
    }
    if (mode == ModeAuthorizeEnum.access && useAuthorize?.isLogged) {
      return (
        <Box
          width="100%"
          height="100%"
          style={{ background: "#1a344f" }}
          position={"fixed"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box p="20px">
            <Box textAlign="center" color="#FFFFFF">
              <Typography variant="subtitle1">Rất tiếc!</Typography>
              <Typography variant="subtitle1">
                Bạn không có quyền xem mục này
              </Typography>
            </Box>
            {/* <Box textAlign='center'>
              <Button startIcon={<ExitToAppIcon />} variant="contained" color="primary" onClick={handleLogout}>
                Đăng xuất
              </Button>
            </Box> */}
          </Box>
        </Box>
      );
    }
    if (mode == ModeAuthorizeEnum.view) {
      return null;
    }
  } else {
    return children;
  }
}
export default Authorize;
